var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from '../../store/connect';
import { ReactiveForm } from '../Form';
import { componentMapper, validatorMapper } from "../Form/form-constants";
import { PriceBreakup } from '../PriceBreakup/PriceBreakup';
import { APP_STATE } from '../../store/store';
import { setAppState, sendFieldValidationErrors, updateForm, goToNextPage, updatePageNumber, resetBookData } from '../../store/actions';
import { getInitialData, getBookEntities, getBookDataPaginatedResponse, getCustomerData, getCustomerListData, getBookDataPaginated, } from '../../store/actions/response.actions';
import { CourseTimespanModel, getBookManager } from '../../models/BookModel';
import { getResponseManager } from '../../responseManager/BeeResponseManager';
import { BookingCartDescription } from './BookingCartDescription';
import { NoDataToDisplay } from '../NoDataToDisplay/NoDataToDisplay';
import { useTranslation } from 'react-i18next';
import { hasAllowAllEvents, getFieldPaths, TIMESPAN_ID_PATH, getSearchAndSelectName, deriveValidationMessages, hasWaitlistBookings, getTimespanId } from './booking-form.helpers';
import get from 'lodash/get';
import pickBy from 'lodash/pickBy';
import styled from 'styled-components';
import { BOOKING_FORM, BUTTON_FORM_SUBMIT } from '../../classConstants';
import { getClassName, useMediaQuery } from '../../helpers';
import { API_METHODS_ENUM } from '../../httpService';
import { LoaderState } from '../../store/actions/loader.actions';
import { Loader } from '../Loader/Loader';
import { TimespanIsFullyBooked } from './TimespanIsFullyBooked';
import { isAdminIntegration } from '../../store/statePresenter';
import qs from "querystring";
import cancelToken, { mockupCancel } from '../../cancelTokens';
import noop from 'lodash/noop';
import { useConfig } from '../../AppContext';
import { getBookingFormManager } from '../../FormManager/BookingFormManager';
import { setParticipantForm } from "../../store/store-helpers";
import { getBookDataResponseManager, isBookDataUpdated } from '../../models/BookModel/helpers';
import assign from 'lodash/assign';
import { useDebouncedQuery } from '../../hooks/useDebouncedQuery';
import { useIsCurrentState } from '../../hooks/appStateHooks';
import { useHadQuery } from '../../hooks/bookDataHooks';
var bookingFormFactory = function () {
    var BookingFormComponent = function (props) {
        var _a, _b;
        var _c = props.className, className = _c === void 0 ? "" : _c, isOneSided = props.isOneSided, resetBookData = props.resetBookData, courseTimespansCount = props.courseTimespansCount, dispatch = props.dispatch, topFormFieldPaths = props.topFormFieldPaths, name = props.name, stageOne = props.stageOne, otherStages = props.otherStages, submitButtonLabel = props.submitButtonLabel, filterQuery = props.filterQuery;
        var oneSidedForm = useConfig("oneSidedForm", isOneSided)[0];
        var campaignName = useConfig("campaignName")[0];
        var showAsWizard = useConfig("bookingForm.showAsWizard", true)[0];
        var showPriceBreakup = useConfig("showPriceBreakup", true)[0];
        var isMobile = useMediaQuery('(max-width: 786px)');
        var onSubmit = props.onSubmit || noop;
        var _d = useState(props.derivedFormValues || {}), formValues = _d[0], setFormValues = _d[1];
        var _e = useState(false), isLastTab = _e[0], setIsLastTab = _e[1];
        var t = useTranslation().t;
        var onBack = useConfig("bookingForm.onBack")[0];
        var submitLabel = t(submitButtonLabel);
        var isFormState = useIsCurrentState(APP_STATE.FORM);
        var hadQuery = useHadQuery();
        var isLoading = props.isLoading && !hadQuery;
        var priceBreakup = useMemo(function () {
            if (!showPriceBreakup) {
                return null;
            }
            return React.createElement(PriceBreakup, { name: name });
        }, [showPriceBreakup, name]);
        var rightSideSection = useMemo(function () {
            if (isLoading)
                return;
            return React.createElement(React.Fragment, null,
                !isMobile && priceBreakup,
                React.createElement(BookingCartDescription, null));
        }, [isLoading, isMobile, priceBreakup]);
        useEffect(function () {
            var _a;
            (_a = props.setHasQuery) === null || _a === void 0 ? void 0 : _a.call(props, !!props.hasQuery);
        }, [props.hasQuery]);
        useEffect(function () {
            setFormValues(props.derivedFormValues);
        }, [JSON.stringify(props.derivedFormValues || {})]);
        var cachedValues = useRef(props.derivedFormValues);
        useEffect(function () {
            if (!props.reset_booking_data)
                return;
            dispatch(updateForm({
                name: props.name,
                form: __assign(__assign({}, cachedValues.current), { reset_booking_data: true })
            }, "reset booking data"));
        }, [props.reset_booking_data, cachedValues]);
        var validationErrorsRef = React.useRef([]);
        var validationErrors = React.useMemo(function () {
            if (!props.validationErrors)
                return validationErrorsRef.current;
            validationErrorsRef.current = deriveValidationMessages(get(props, "formManager"), props.validationErrors, topFormFieldPaths.split("$$$$"), otherStages);
            return validationErrorsRef.current;
        }, [props.validationErrors, topFormFieldPaths, otherStages]);
        var schema = props.getSchema({ eventForm: stageOne, otherSteps: otherStages }, {
            onNextWizardState: function (currentStep, isLast) {
                setIsLastTab(isLast);
            },
            onBack: onBack,
            showAsWizard: showAsWizard,
            backLabel: t("bookcart.back"),
            submitLabel: isLastTab ? submitLabel : t("bookcart.next_step"),
            invalidStepIndex: props.invalidStepIndex,
            leftSideOnly: oneSidedForm,
            leftSideSection: (oneSidedForm || isMobile) && priceBreakup,
            rightSideSection: rightSideSection,
            className: getClassName(className, BOOKING_FORM),
        }, validationErrors);
        var formManagerRef = useRef(null);
        formManagerRef.current = get(props, "formManager");
        var handleFormSubmit = useCallback(function (formData) {
            var _a, _b, _c;
            if (showAsWizard !== false && !isLastTab)
                return;
            setParticipantForm((_a = formManagerRef.current) === null || _a === void 0 ? void 0 : _a.state);
            (_b = formManagerRef.current) === null || _b === void 0 ? void 0 : _b.setCampaignName(campaignName);
            var request = (_c = formManagerRef.current) === null || _c === void 0 ? void 0 : _c.toRequestBody(topFormFieldPaths.split("$$$$"));
            onSubmit(request);
        }, [onSubmit, showAsWizard, isLastTab, campaignName]);
        // Reset Page number to 1.
        useEffect(function () {
            return function () {
                resetBookData(true);
            };
        }, []);
        var book_data_cancel_token = useState(function () { return cancelToken(name + "book_data_api_cancel_token"); })[0];
        useDebouncedQuery(function (query) {
            dispatch(getBookEntities(query, { cancelToken: book_data_cancel_token, }));
        }, props.queryString, filterQuery);
        // Ensure App state is booking form
        useEffect(function () {
            dispatch(setAppState(APP_STATE.FORM));
        }, []);
        var selectedCourseTimespan = get(formValues, TIMESPAN_ID_PATH, null);
        useEffect(function () {
            dispatch(sendFieldValidationErrors(null));
        }, [selectedCourseTimespan]);
        if (!isFormState)
            return null;
        if (props.hasErrored)
            return null;
        if (isLoading)
            return React.createElement(Loader, null);
        if (!props.showTimespanSearchAndSelect && courseTimespansCount === 0)
            return React.createElement(NoDataToDisplay, null);
        if (((_b = (_a = schema === null || schema === void 0 ? void 0 : schema.schema) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.length) === 0)
            return null;
        return React.createElement(React.Fragment, null,
            React.createElement(TimespanIsFullyBooked, { name: props.name }),
            React.createElement(ReactiveForm, __assign({}, schema, { componentMapper: componentMapper, validatorMapper: validatorMapper, initialValues: formValues, onSubmit: handleFormSubmit })));
    };
    function mapStateToProps(state, ownProps) {
        var _a, _b, _c, _d;
        var adminIntegration = isAdminIntegration(state);
        var form = (_a = get(ownProps, 'dirty_form')) !== null && _a !== void 0 ? _a : get(state, "formReducer.forms." + ownProps.name, {});
        var _e = state.appReducer || {}, validationErrors = _e.validationErrors, queryString = _e.queryString;
        var initialData = (_b = getInitialData(state.responseReducer)) === null || _b === void 0 ? void 0 : _b.response;
        var loadingState = new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.GET_BOOK_ENTITIES] });
        return {
            form: form,
            customerId: form.customerId || ownProps.customerId || "",
            adminSettings: get(state, "formReducer.forms.adminsettings"),
            bookData: getBookDataPaginatedResponse(state.responseReducer),
            additionalProps: state.courseReducer.additionalProps,
            queryString: ownProps.queryString || queryString || '',
            resolvedQueryString: __spreadArray([], getBookDataPaginated(state.responseReducer)).map(function (x) { return x.queryString; }).filter(Boolean).pop(),
            initialData: initialData,
            isAdminIntegration: adminIntegration,
            validationErrors: validationErrors,
            savedParticipantForm: get(state, "appReducer.savedParticipantForm", null),
            isLoading: loadingState.loading,
            hasLoaded: loadingState.loaded,
            hasErrored: loadingState.errored,
            isLoadingCustomers: new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.GET_CUSTOMER_LIST] }).loading,
            isSubmiting: new LoaderState(state.loaderReducer, { keys: [API_METHODS_ENUM.POST_BOOKING_FORM] }).loading,
            pageNumber: get(state, "courseReducer.pageNumber", 1),
            pageSize: Math.max(get(state, "courseReducer.pageSize", 10), 10),
            hasServerFilters: state.courseReducer.hasServerFilters,
            customerData: (_c = getCustomerData(get(state, "responseReducer", {}))) === null || _c === void 0 ? void 0 : _c.response,
            customerList: (_d = getCustomerListData(get(state, "responseReducer", {}))) === null || _d === void 0 ? void 0 : _d.response,
        };
    }
    function mergeProps(stateprops, dispatchProps, ownProps) {
        var _a, _b;
        var _c, _d;
        var hasServerFilters = stateprops.hasServerFilters, additionalProps = stateprops.additionalProps, bookData = stateprops.bookData, _e = stateprops.form, form = _e === void 0 ? {} : _e, isLoading = stateprops.isLoading, hasLoaded = stateprops.hasLoaded, hasErrored = stateprops.hasErrored, _f = stateprops.adminSettings, adminSettings = _f === void 0 ? {} : _f, isSubmiting = stateprops.isSubmiting, isLoadingCustomers = stateprops.isLoadingCustomers, initialData = stateprops.initialData, resolvedQueryString = stateprops.resolvedQueryString, validationErrors = stateprops.validationErrors, loaderState = stateprops.loaderState, pageNumber = stateprops.pageNumber, pageSize = stateprops.pageSize, otherStateProps = __rest(stateprops, ["hasServerFilters", "additionalProps", "bookData", "form", "isLoading", "hasLoaded", "hasErrored", "adminSettings", "isSubmiting", "isLoadingCustomers", "initialData", "resolvedQueryString", "validationErrors", "loaderState", "pageNumber", "pageSize"]);
        var apiCancelToken = ownProps.apiCancelToken, otherOwnProps = __rest(ownProps, ["apiCancelToken"]);
        var initialDataRM = initialData && getResponseManager(initialData);
        var showTimespanSearchAndSelect = ownProps.showTimespanSearchAndSelect;
        var showCustomerSearchAndSelect = ownProps.showCustomerSearchAndSelect;
        var isAdminIntegration = stateprops.isAdminIntegration;
        var bookDataRM = getBookDataResponseManager(bookData);
        var mergedProps = __assign(__assign(__assign(__assign({ isOneSided: true, validationErrors: validationErrors }, otherStateProps), dispatchProps), otherOwnProps), { queryString: stateprops.queryString, derivedFormValues: __assign(__assign({}, form), adminSettings), stageOne: [], otherStages: [], topFormFieldPaths: "", courseTimespansCount: 0, invalidStepIndex: null, submitButtonLabel: "", filterQuery: get(form, getSearchAndSelectName(TIMESPAN_ID_PATH), ""), hasErrored: hasErrored, burstCache: CourseTimespanModel.burstCache, isLoading: !(isAdminIntegration && showTimespanSearchAndSelect) && (!bookDataRM && (isLoading || hasLoaded)) });
        var bmOptions = {
            showCustomerSearchAndSelect: showCustomerSearchAndSelect,
            showTimespanSearchAndSelect: showTimespanSearchAndSelect,
            isAdminIntegration: isAdminIntegration,
            disableAvailabilityCheck: isAdminIntegration && hasAllowAllEvents(adminSettings),
            isFixedTimespan: get(ownProps, "attributes.ftimespans", false),
            courses: [].concat(get(additionalProps, "fcourses")).filter(Boolean),
            apiCancelToken: apiCancelToken || mockupCancel,
            originalParticipantStepName: true,
            isLoadingBookEntities: isLoading,
            hasServerFilters: hasServerFilters,
            showBookedItems: false,
            showSaveParticipants: ownProps.showSaveParticipants,
            savedParticipantForm: stateprops.savedParticipantForm,
            name: ownProps.name,
            customerList: get(stateprops, "customerList.body", []),
            customerData: get(stateprops, "customerData.body", {}),
            showParticipantDropdown: get(mergedProps.derivedFormValues, "additional_props.save_participant_data"),
            isLoadingCustomers: isLoadingCustomers,
        };
        var stateQs = qs.parse(mergedProps.queryString);
        var mergeQueryString = function (o) {
            var resolvedQs = qs.parse(resolvedQueryString);
            var timespanId = getTimespanId(o.derivedFormValues);
            var parsedQs = assign(stateQs, {
                allow_all_events: stateprops.isAdminIntegration && hasAllowAllEvents(o.derivedFormValues),
                waitlist_bookings: stateprops.isAdminIntegration && hasWaitlistBookings(o.derivedFormValues),
                query: o.filterQuery,
                timespans: o.filterQuery || resolvedQs.timespans === timespanId ? timespanId : undefined,
                page: pageNumber,
                perPage: pageSize,
                debugTimespanCount: undefined,
                courses: get(form, "categoryNames", []).join(","),
                places: get(form, "placeName", ""),
            });
            return assign(mergedProps, {
                hasQuery: !!parsedQs.query,
                queryString: qs.stringify(pickBy(parsedQs, Boolean)),
            });
        };
        if (initialData && bookDataRM) {
            var options = initialDataRM.options();
            var optionEntities = initialDataRM.entities();
            var entities = bookDataRM.entities || {};
            var waitListEntities = bookDataRM.waitlist_entities || {};
            var lastPageNumber = (_d = (_c = bookDataRM.pagination) === null || _c === void 0 ? void 0 : _c.lastPage) !== null && _d !== void 0 ? _d : 0;
            if (!entities.form_items && !ownProps.hideTopForm)
                return mergeQueryString(mergeProps);
            var defaultFormData = bookDataRM.form_data;
            var em = getBookManager(__assign(__assign({}, entities), optionEntities), __assign(__assign(__assign({}, options), bmOptions), { loadMoreBookEntities: pageNumber < lastPageNumber ? dispatchProps.loadMoreBookEntities : null, resetPageNumber: dispatchProps.resetPageNumber, waitListEntities: waitListEntities,
                defaultFormData: defaultFormData }));
            try {
                var clearedForm = __assign({}, form);
                if (clearedForm.reset_booking_data) {
                    delete clearedForm.booking_data;
                    delete clearedForm.categoryNames;
                    delete clearedForm.placeName;
                }
                var formManager = getBookingFormManager({
                    modelManager: em,
                    form: __assign(__assign({}, clearedForm), { customerId: stateprops.customerId })
                }, __assign(__assign({}, bmOptions), { addOnlyTimespanByDefault: true, defaultFormData: defaultFormData,
                    waitListEntities: waitListEntities,
                    adminSettings: adminSettings }));
                var derivedFormData = formManager.state;
                mergedProps.formManager = formManager;
                mergedProps.courseTimespansCount = em.courseTimespans().size;
                (_a = mergedProps.stageOne).push.apply(_a, em.getEventForm(derivedFormData, __assign({}, options)));
                if (!ownProps.hideTopForm)
                    (_b = mergedProps.otherStages).push.apply(_b, em.getFormSteps(derivedFormData, validationErrors));
                if (!ownProps.submitButtonLabel)
                    mergedProps.submitButtonLabel = em.getSubmitButtonLabel(derivedFormData, options);
                mergedProps.derivedFormValues = formManager.toJSON(derivedFormData.getFormDefaultValues());
                mergedProps.isOneSided = !!(options === null || options === void 0 ? void 0 : options.is_booking_form_one_sided) || !(options === null || options === void 0 ? void 0 : options.book);
                mergedProps.topFormFieldPaths = getFieldPaths(mergedProps.otherStages, mergedProps).join("$$$$");
                mergedProps.filterQuery = get(mergedProps.derivedFormValues, getSearchAndSelectName(TIMESPAN_ID_PATH), "");
            }
            catch (e) {
                console.error(e);
                throw e;
            }
            if (mergedProps.invalidStepIndex !== null)
                mergedProps.invalidStepIndex++;
            if (isSubmiting) {
                mergedProps.invalidStepIndex = null;
            }
        }
        else if (isAdminIntegration && showTimespanSearchAndSelect) {
            var bm = getBookManager({}, bmOptions);
            var timespanSearchandSelect = bm.getTimespanSearchAndSelect(mergedProps.derivedFormValues);
            if (timespanSearchandSelect)
                mergedProps.stageOne.push(timespanSearchandSelect);
            var customerSearchAndSelect = bm.getCustomerSearchAndSelect(mergedProps.derivedFormValues);
            if (customerSearchAndSelect)
                mergedProps.stageOne.push(customerSearchAndSelect);
        }
        mergeQueryString(mergedProps);
        if (isLoading && mergedProps.derivedFormValues.booking_data && !bookDataRM && !!stateQs.bookingId) {
            mergedProps.reset_booking_data = true;
        }
        return mergeQueryString(mergedProps);
    }
    var mapDispatchToProps = function (dispatch) {
        return {
            dispatch: dispatch,
            loadMoreBookEntities: function () { return dispatch(function (_, getState) {
                var _a, _b;
                if (new LoaderState(getState().loaderReducer, { keys: [API_METHODS_ENUM.GET_BOOK_ENTITIES] }).loading)
                    return;
                var lastPage = (_b = (_a = getBookDataResponseManager(getBookDataPaginatedResponse(getState().responseReducer))) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.lastPage;
                if (!lastPage)
                    return;
                dispatch(goToNextPage(lastPage));
            }); },
            resetPageNumber: function () { return dispatch(updatePageNumber(1)); },
            resetBookData: resetBookData
        };
    };
    return connect(mapStateToProps, mapDispatchToProps, mergeProps, isBookDataUpdated("bookData"))(BookingFormComponent);
};
export var BookingForm = styled(bookingFormFactory())(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .", " {\n        flex: 1\n    }\n"], ["\n    .", " {\n        flex: 1\n    }\n"])), BUTTON_FORM_SUBMIT);
var templateObject_1;
